
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","viewBox":"0 0 22 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.812 3.702c-1.022.17-1.512 1.096-1.094 2.07.443 1.026 1.708 1.684 2.75 1.424.924-.228 1.35-1.112.95-2.04-.418-.973-1.585-1.624-2.606-1.454zm1.32 2.665l.092.204-.195.04-.086-.195c-.2.036-.428.031-.639-.024l-.058-.344c.174.027.39.052.554.018l.111-.037c.197-.097.135-.344-.156-.402-.218-.048-.794-.013-1.01-.491-.12-.27-.03-.552.317-.68l-.096-.213.193-.04.093.203a2 2 0 01.5-.015l.077.34a1.452 1.452 0 00-.455-.007l-.053.015c-.275.073-.187.333.057.396.402.093.883.124 1.074.544.153.342-.025.576-.32.688zm9.166.94L17.95 0C12.46 3.56 6.388-.283 1.994 3.96l3.346 7.306c4.71-3.993 11.128-.212 15.958-3.96zM18.806 5.66a4.77 4.77 0 00-.728 1.548c-3.194.972-7.014-.179-10.682 1.103-.593-.315-1.336-.512-1.946-.494l-1.01-2.21c.385-.467.687-1.179.817-1.862 3.021-1.09 6.802.138 10.843-1.245.463.307 1.004.53 1.537.64l1.17 2.52zm2.527 5.016C15.238 14.179 10.312 9.41 4 16L0 7.138l1.246-1.3 3.384 7.471-.002.007c6.618-4.974 9.952-1.046 16.097-4.056.262.576.503 1.184.608 1.416z","fill":"#3F51B5"}})])
          )
        }
      }
    